import { PaymentPollingStatusType } from "../../../../../../api/payments/types.ts";

export const PaymentStatusTranslation: Record<PaymentPollingStatusType, string> = {
  DONE: "Оплачено успешно",
  IN_PROGRESS: "Ваш платеж находится в обработке",
  ERROR: "Оплата не прошла, попробуйте еще раз",
  TEMPORARY_ERROR_FIN: "Оплата не прошла, попробуйте еще раз",
  NOT_ENOUGH_MONEY_SBP_FIN: "Недостаточно средств. Пополните счёт или измените способ оплаты",
  NOT_ENOUGH_MONEY_CARD_FIN: "Недостаточно средств. Пополните счёт или измените способ оплаты",
  COUNT_LIMIT_EXCEEDED_SBP_FIN: "Превышен лимит операций. Попробуйте через сутки или измените способ оплаты",
  PAYER_BANK_REFUSAL_SBP_FIN: "Банк отклонил платёж. Попробуйте еще раз или измените способ оплаты",
  ACCOUNT_BINDING_NOT_FOUND_SBP_FIN: "Ваш привязанный счет был отключен банком. Для продолжения операции необходимо повторно привязать счет или выбрать другой способ оплаты",
};
